<template>
<!-- cp_type

1 赠送
2 出售
3 注册
4 生日
 -->
<div>
  <div class="cardcenter">
    <div v-if="list.length > 0" class="list">
      <div v-for="(v,k) in list" v-bind:key="k" :class="[v.cp_type==1 || v.cp_type==3 || v.cp_type==4?'blue':'']" class="item">
        <div class="box">
          <div class="num">
            ￥<span>{{v.money}}</span>
          </div>
          <div class="txt">
            <p class="tit">{{v.title}}</p>
            <!-- {{v.cp_type}} -->
            <!-- <p class="stit">余额充值券</p> -->
          </div>
          <div class="btnbox">
            <div v-if="v.cp_type==1 || v.cp_type==3 || v.cp_type==4 || v.cp_type==5" @click="couponGet(v)" class="btn">立即领取</div>
            <div v-if="v.cp_type==2" @click="couponBuy(v)" class="btn">立即购买</div>
          </div>
        </div>
        <div v-if="v.cp_type==1 || v.cp_type==3 || v.cp_type==4 || v.cp_type==5" class="time">价格：免费</div>
        <div v-if="v.cp_type==2" class="time">价格：￥{{v.price}}</div>
      </div>
    </div>
    <div v-else class="nodata">暂无数据</div>
    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10"></div>
  </div>
  <div class="weui-loadmore" v-if="load">
      <i class="weui-loading"></i>
      <span class="weui-loadmore__tips">正在加载</span>
  </div>
  <!-- <footbottom></footbottom> -->
</div>
</template>

<script>
import infiniteScroll from '@/basic/infiniteScroll'
import footbottom from '@/footer'
export default{
  components:{
    footbottom
  },
  directives: {infiniteScroll},
  data(){
    return{
      list:[],
      busy: true,
      load:true,
      page:1
    }
  },
  mounted(){
    this.getCoupon();
  },
  methods:{
    getCoupon(flag){
      let vm = this;
      vm.ajax("coupon", "get", 'page='+vm.page, e => {
        vm.load = false;
        if(e.data.list){
          if(flag){
            vm.list =  vm.list.concat(e.data.list)
            if(e.data.count == vm.page){
                vm.busy = true;
            }else{
                vm.busy = false;
            }
          }else{
            vm.list =  e.data.list;
            if(vm.list.length < e.data.limit){
              vm.busy = true;
            }else{
              vm.busy = false;
            }
          }
        }else{
          vm.busy = true;
        }
      })
    },
    loadMore() {
      let vm = this;
      vm.busy = true;
      vm.load = true;
      setTimeout(() => {
          vm.page++;
          vm.getCoupon(true);
      }, 1000);
    },
    couponBuy(v){
      let vm = this;
      if(!(v.id>0)){
        vm.publics.message.danger('该优惠券不存在！');
        return false;
      }
      var data = JSON.stringify({"id":v.id});
      var xhr = new XMLHttpRequest();
      xhr.withCredentials = true;

      xhr.addEventListener("readystatechange", function() {
          if (this.readyState === this.DONE) {
              console.log(this.responseText);

              let response = JSON.parse(this.response);

              if (response.code != 1000) {
                  alert(response.error)
              } else {
                  // ----- pay weixin ---
                  var req = response.data;
                  if (typeof WeixinJSBridge == "undefined") {
                      if (document.addEventListener) {
                          document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                      } else if (document.attachEvent) {
                          document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                          document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                      }
                  } else {
                      WeixinJSBridge.invoke(
                          'getBrandWCPayRequest', req,
                          function(res) {
                              if (res.err_msg == "get_brand_wcpay_request:ok") {
                                  // 使用以上方式判断前端返回,微信团队郑重提示：
                                  //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                                  if (res.err_msg == "get_brand_wcpay_request:ok") {
                                    vm.publics.message.success('购买成功，请查看券盒');
                                  } else {
                                      // alert("error")
                                      //支付失败/或取消支付跳转页面
                                  }
                              }
                          });
                  }

                  // -- pay end --
              }


          }

      });
      xhr.open("POST", vm.publics.API_URL+"coupon/buy");
      xhr.setRequestHeader("content-type", "application/json");

      xhr.send(data);
    },
    couponGet(v){
      let vm = this;
      if(!(v.id>0)){
        vm.publics.message.danger('该优惠券不存在！');
        return false;
      }
      vm.ajax("coupon/get", "post", {
        id:v.id
      }, e => {
        vm.publics.message.success('领取成功，请查看券盒');
        vm.getCoupon();
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/cardcenter.vue